import { render, staticRenderFns } from "./App-index.vue?vue&type=template&id=59f70b57&scoped=true"
import script from "./App-index.vue?vue&type=script&lang=js"
export * from "./App-index.vue?vue&type=script&lang=js"
import style0 from "./App-index.vue?vue&type=style&index=0&id=59f70b57&prod&scoped=true&lang=scss"
import style1 from "./App-index.vue?vue&type=style&index=1&id=59f70b57&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f70b57",
  null
  
)

export default component.exports